import { type Translation } from '@shared/translation';
import { type ReactNode } from 'react';
import { Toolbar } from '@/component/Layout';
import Pane from '@/component/Layout/PaneFixedHeader';

interface PageProps {
  title: Translation;
  actions?: ReactNode;
  children: ReactNode;
}

export const Page = ({ title, actions, children }: PageProps) => {
  return (
    <Pane>
      <Pane.Header>
        <Toolbar title={title} actionButtons={<>{actions}</>} />
      </Pane.Header>
      <Pane.Content>{children}</Pane.Content>
    </Pane>
  );
};
